// this is a refactor of keyMirror here to allow an added prefix:
//   https://git.hubteam.com/HubSpot/react-utils/blob/master/static/js/keyMirror.js
// TODO: suggest this as replacement for keyMirror in react-utils
const keyMirror = (obj, prefix = '') => {
  const ret = {};
  let key;
  if (!(obj instanceof Object && !Array.isArray(obj))) {
    throw new Error('keyMirror(...): Argument must be an object.');
  }
  for (key in obj) {
    /* eslint-disable-next-line no-prototype-builtins */
    if (!obj.hasOwnProperty(key)) {
      continue;
    }
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    ret[key] = prefix + key;
  }
  return ret;
};
export default keyMirror;